<template>
  <div class="rating_page">
    <!-- header start -->
    <van-nav-bar
      title="查看产品"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <!-- header end -->
      <div class="m-pro-body">
        <van-list
          v-model="loading"
          :finished="finished"
          :offset="offset"
          finished-text="没有更多了"
          @load="loadMore"
        >
          <router-link
            :to="'/MProductDetails?id='+item.SerialNumber"
            class="m-pro-list"
            v-for="item in dataList"
            :key="item.SerialNumber"
          >
            <div class="hd">
              <img :src="item.CoverPhoto" alt class="avatar" />
            </div>
            <div class="bd">
              <h2 class="title">{{item.DProductName}}</h2>
              <div class="price">
                ￥
                <span class="money">{{item.Price}}</span>
              </div>
            </div>
          </router-link>
        </van-list>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      options: null,
      dataList: null,
      isFirstEnter:false 
    };
  },
  computed: {},
  components: {},
  mounted() {
    var _query = this.$route.query;
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
      
    console.log(_query);
    this.init(_query.did);
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init(did) {
      var that = this;
      that.options = {
        type: "DistributionProductSearch",
        Did: did,
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      that.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.DistributionProductApiModelList.length <= 0) {
            that.finished = true;
          }
          if (this.options.pageIndex > 1) {
            if (res.DistributionProductApiModelList.length > 0) {
              res.DistributionProductApiModelList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = res.DistributionProductApiModelList;
          }
        },
        error => {}
      );
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  beforeRouteEnter(to, from, next) {
    //路由进入执行
    if(from.name=="MProductDetails")
    {
        to.meta.isBack=true;
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  activated(){
    var _query = this.$route.query;
    console.log("activated");
    console.log(this.$route.meta.isBack+"___"+this.isFirstEnter);
      if(!this.$route.meta.isBack || this.isFirstEnter){
       this.init(_query.did);
     }
     this.$route.meta.isBack=false;
     this.isFirstEnter=false;

  },
  created() {
    this.isFirstEnter=true;
  }
};
</script>

<style scoped>
	.rating_page{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
        /* padding-top: 1.95rem; */
		background-color: #ebebeb;
		z-index: 18;
	}
.m-pro-body {
  background-color: #fff;
  overflow: hidden;
  padding: 1.5%;
}
.m-pro-list {
  width: 50%;
  float: left;
  padding: 1.5%;
}
.m-pro-list > .hd {
  position: relative;
  height: 0;
  font-size: 0;
  padding-bottom: 100%;
}
.m-pro-list > .hd > .avatar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.m-pro-list > .bd {
  padding: 6px 4px;
}
.m-pro-list > .bd > .title {
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.m-pro-list > .bd > .price {
  font-size: 12px;
  color: crimson;
  margin-top: 2px;
}
.m-pro-list > .bd > .price .money {
  font-size: 18px;
}
</style>
